import { HtmlRulesComponent, PaytableRowData } from "slotworks/components/html-rules/html-rules-component";

export class ThemeHtmlRulesComponent extends HtmlRulesComponent {

    constructor() {
        super(2);
    }

    public symbolImageMap() {
        return new Map<string, string | null>([
            ['X2X3X3X2', 'X2X3'],
            ['X2X3X3', 'X2X3-any'],
            ['H1H1H1H1', 'H1'],
            ['H1H1H1', 'H1-any'],
            ['H2H2H2H2', 'H2'],
            ['H2H2H2', 'H2-any'],
            ['H3H3H3H3', 'H3'],
            ['H3H3H3', 'H3-any'],
            ["H1H2H3","any7"],
            ["H1H2H3","any7"]
        ]);
    }

    protected override buildPaytableHtml(data: Array<PaytableRowData>): string {
        const getImageNameForSymbol = (symbolId: string) => this.symbolImageMap().get(symbolId) || symbolId;

        const customSymbols = ["X2", "X3", "X3", "X2"];
        const getSymbols = (rowData: PaytableRowData, columns: number, custom: boolean) => {
            if(custom) {
                let symbols = "";
                for(let i = 0; i < columns; i++) {
                    symbols = symbols.concat(`<img src="./img/mobile/General/${getImageNameForSymbol(customSymbols[i])}@2.25x.png"/>`);
                }
                return symbols;
            }
            else {
                return `<img src="./img/mobile/General/${getImageNameForSymbol(rowData.symbolId)}@2.25x.png"/>`.repeat(columns);
            }
        }

        const rows = [4, 3, 4, 3, 4, 3, 4, 3, 4, 3];
        const customRow = [true, true, false, false, false, false, false, false]
        let count = 0;
        const getRow = (rowData: PaytableRowData) => {
            let output =
            `<tr>
                <td class="symbols">
                    ${getSymbols(rowData, rows[count], customRow[count])}
                </td>
                <td class="amount text-size-70">
                    ${rowData.payout.toLocaleString()}
                </td>
            </tr>`;
            count++;
            return output;
        }

        const getTable = (data: Array<PaytableRowData>) => `<table>${data.map(getRow).join('')}</table>`;

        const tables = [];
        for(let i = 0; i < data.length; i += this.numRowsPerPaytable) {
            const tableData = data.slice(i, i + this.numRowsPerPaytable).sort((a, b) => { return b.payout - a.payout });
            tables.push(getTable(tableData));
        }
        return `<div>${tables.join('')}</div>`;
    }

    protected override addPaylines(paylines: number[][]) {
        const paylineHtml = paylines.map((payline, index) => `<div class="payline">
            <div class="payline-header">${index + 1}</div>
                <div class="payline-tablewrapper">
                    <table class="paylines a${payline[0] + 1} b${payline[1] + 1} c${payline[2] + 1} d${payline[3] + 1}">
                        <tr class="row1">
                            <td class="cola"></td>
                            <td class="colb"></td>
                            <td class="colc"></td>
                            <td class="cold"></td>
                        </tr>
                        <tr class="row2">
                            <td class="cola"></td>
                            <td class="colb"></td>
                            <td class="colc"></td>
                            <td class="cold"></td>
                        </tr>
                        <tr class="row3">
                            <td class="cola"></td>
                            <td class="colb"></td>
                            <td class="colc"></td>
                            <td class="cold"></td>
                        </tr>
                    </table>
                </div>
            </div>`)
            .join('\n');
        const paylinesWrapper = document.getElementById("paylineswrapper");
        if(paylinesWrapper) {
            paylinesWrapper.insertAdjacentHTML('afterbegin', paylineHtml);
        }
    }
}